import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: "app-twofa-qr-modal",
  templateUrl: "./twofa-qr-modal.component.html",
  styleUrls: ["./twofa-qr-modal.component.scss"],
})
export class TwoFaQrModalComponent {
  qrImageUrl = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TwoFaQrModalComponent>
  ) {
    const qrCode = data && data.QrCode ? String(data.QrCode) : "";
    this.qrImageUrl =
      "https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=" +
      encodeURIComponent(qrCode);
  }

  close() {
    this.dialogRef.close();
  }
}

